var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.4458 19.3283H4.42349L4.40126 19.3303C4.18515 19.3496 3.85398 19.3024 3.59139 19.1148C3.35663 18.9471 3.11377 18.6237 3.11377 17.9471V5.99435L3.9458 5.99469V17.9471V18.4471H4.4458H18.445V19.3283H4.4458Z",
    stroke: "#623CE7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75391 13.923V5.79381C6.75391 4.89588 7.48182 4.16797 8.37974 4.16797H12.1076C12.3232 4.16797 12.53 4.25362 12.6824 4.40607L14.0702 5.79381H19.7606C20.6585 5.79381 21.3864 6.52172 21.3864 7.41964V13.923C21.3864 14.8209 20.6585 15.5488 19.7606 15.5488H8.37974C7.48182 15.5488 6.75391 14.8209 6.75391 13.923Z",
    fill: "#623CE7",
    stroke: "#623CE7",
    strokeWidth: 1.62584,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.a6c1679b5c3e893086a861591609c6aa.svg";
export { ForwardRef as ReactComponent };